import classNames from 'classnames';
import { noop } from 'lodash/fp';
import { Component } from 'react';
import styled from 'styled-components';
import { LocalizedText } from '@mews/framework';
import { alpha, Button, getToken, IconButton, IconName } from '@optimus-web/core';
import { COLOR_WHITE } from '../../../components/commander-ui/constants';

const ActionButtonElement = styled(Button)`
    color: ${COLOR_WHITE} !important;
    background: transparent !important;
    margin-right: 8px;
`;

const CloseButton = styled(IconButton)`
    background: transparent;
    margin-right: 8px;
    color: ${COLOR_WHITE};

    &:focus:not(:active) {
        background-color: ${({ theme }) => alpha(getToken('paletteBrandNight1000')({ theme }), 0.4)};
    }
`;

interface OwnProps {
    action?: {
        labelKey?: string;
        onClick?: $TSFixMeFunction;
    };
    dismissible?: boolean;
    id: string;
    message?: string;
    messageKey?: string;
    messageSubstitutes?: {};
    onDismissClick?: $TSFixMeFunction;
    type: $TSFixMe; // TODO: pt.instanceOf(AlertType)
}

type Props = OwnProps & {
    onDismissClick: (id: string) => void;
    messageSubstitutes: Record<string, string>;
};

class Alert extends Component<Props> {
    static defaultProps = {
        onDismissClick: noop,
        messageSubstitutes: {},
    };

    handleActionClick = () => {
        this.props.action?.onClick?.();
    };

    handleDismissClick = () => {
        this.props.onDismissClick(this.props.id);
    };

    render() {
        const { action, dismissible, messageKey, messageSubstitutes, message, type } = this.props;
        const css = {
            alert: true,
            'z-depth-2-bottom': true,
            'alert-dismissible': dismissible,
            [this.props.type.value]: true,
        };

        const actionButton = action ? (
            <ActionButtonElement onClick={this.handleActionClick} size="medium" type="submit">
                <LocalizedText textKey={action.labelKey as Mews.TextKey} />
            </ActionButtonElement>
        ) : null;

        const dismissButton = dismissible ? (
            <CloseButton icon={IconName.CrossClose} onClick={this.handleDismissClick} variant="ghost" type="button" />
        ) : null;

        return (
            <div className={classNames(css)} data-test-alert={type.name}>
                <span className="message" data-test-alert-title>
                    {this.props.messageKey ? (
                        <LocalizedText textKey={messageKey as Mews.TextKey} substitutes={messageSubstitutes} />
                    ) : (
                        message
                    )}
                </span>
                {actionButton}
                {dismissButton}
            </div>
        );
    }
}

export default Alert;
